import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/login-verify")({
  staticData: { title: "Login Verify" },
  component: lazyRouteComponent(
    () => import("#pages/login/login-verify.tsx"),
    "LoginVerify",
  ),
})
